/* eslint-disable @typescript-eslint/no-explicit-any */
import { Environment } from '@thiememeulenhoff/types';

export const GlobalConfigKey = Symbol('TM_GLOBAL_CONFIG');

export interface GlobalConfig {
  environment: Environment;
}

export const DefaultGlobalConfig: GlobalConfig = {
  environment: Environment.Test,
};

export const setGlobalConfig = (config: any) => {
  (window as any)[GlobalConfigKey] = config;
};

export const getGlobalConfig = (): GlobalConfig => {
  return (window as any)[GlobalConfigKey] || DefaultGlobalConfig;
};
